import { Vector2 } from 'three';

export const shaderChunks = {
    uniforms: () => ({
        uShockCenter: { value: new Vector2() },
        uShockT: { value: 0 },
    }),
    funcs: /* glsl */ `
        uniform vec2 uShockCenter;
        uniform float uShockT;

        vec3 applyPeekShock(vec3 color, vec3 positionW) {
            float shockActive = step(0.001, uShockT) * step(uShockT, 0.999);
            float shockDist = length(positionW.xy - uShockCenter);
            float shockRadius = uShockT * 0.55;
            float ring = max(0.0, 1.0 - abs(shockDist - shockRadius) / 0.13);
            ring = pow(ring, 1.2) * shockActive;
            float shockFade = pow(1.0 - uShockT, 0.7);
            float tintBias = clamp(positionW.y * 1.5 + 0.5, 0.0, 1.0);
            vec3 shockTint = mix(vec3(1.0, 0.5, 1.0), vec3(0.45, 0.85, 1.0), tintBias);
            return color + shockTint * ring * shockFade * 1.1;
        }
    `,
};
